export const TYPE_TO_LABEL_MAP = {
  persistent: "Persistent",
  geo: "Geo",
  fulltext: "Fulltext",
  ttl: "TTL",
  mdi: "MDI",
  "mdi-prefixed": "MDI (Prefixed)",
  inverted: "Inverted",
  vector: "Vector",
  tier: "Tier",
  primary: "Primary",
  edge: "Edge",
  arangosearch: "ArangoSearch"
};
